import React, { FC } from 'react';
import styles from './validationModal.module.scss';
import { Col, Modal, Row } from 'antd';
import COButton from 'shared/components/COButton';
import { ButtonSize } from 'enums/ButtonEnums';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { modalCloseIcon } from 'shared/components/OrganizationModal';

interface ValidationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

enum ValidationModalEnum {
  CLOSE_TEXT = 'Go back',
  SUB_TITLE_TEXT = 'You cannot unlink this organization from this year.',
  VALIDATION_INFO = 'Since this organization is not associated with any specific year, it is necessary to link the organization to at least one year.',
}

const ValidationModal: FC<ValidationModalProps> = ({ isOpen, onClose }) => {
  const footer = (
    <Row
      gutter={[25, 25]}
      className={styles.validationFooter}
      justify={'center'}>
      <Col span={24}>
        <COButton secondary size={ButtonSize.LARGE} onClick={onClose}>
          {ValidationModalEnum.CLOSE_TEXT}
        </COButton>
      </Col>
    </Row>
  );
  return (
    <div>
      <Modal
        destroyOnClose={true}
        maskClosable={false}
        centered
        width={450}
        footer={footer}
        wrapClassName={styles.modalContainer}
        open={isOpen}
        closeIcon={modalCloseIcon}
        onCancel={onClose}>
        <Row className={styles.confirmationContent}>
          <Col span={24} className={styles.validationTitle}>
            {ValidationModalEnum.SUB_TITLE_TEXT}
          </Col>
          <Col span={24} className={styles.validationInfo}>
            {ValidationModalEnum.VALIDATION_INFO}
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default ValidationModal;
